/**
 * Profile Visibility Utilities
 * Helpers to determine if profile data is empty and should be hidden on public profiles
 */

/**
 * Whether the Platform Performance section should be shown.
 * Default-on: visible when not explicitly set to false.
 * @param {Record<string, boolean> | null | undefined} sectionsEnabled - Profile sectionsEnabled
 * @returns {boolean} - true if undefined or true, false only when explicitly false
 */
export function shouldShowPlatformPerformance(sectionsEnabled) {
  if (sectionsEnabled == null || typeof sectionsEnabled !== 'object') return true;
  const v = sectionsEnabled.platformPerformance;
  return v !== false;
}

/**
 * Check if a value is considered empty
 * @param {unknown} value - The value to check
 * @returns {boolean} - True if the value is empty
 */
export function isEmptyValue(value) {
  if (value === null || value === undefined) return true;
  if (typeof value === 'string' && value.trim() === '') return true;
  // Treat 0 as a VALID value (for counts/percentages)
  return false;
}

/**
 * Check if an object has any non-empty values
 * @param {Record<string, unknown> | null | undefined} obj - The object to check
 * @returns {boolean} - True if the object has at least one non-empty value
 */
export function hasAnyData(obj) {
  if (!obj) return false;
  return Object.values(obj).some((v) => !isEmptyValue(v));
}

/**
 * Check if an array has any non-empty values
 * @param {unknown[] | null | undefined} arr - The array to check
 * @returns {boolean} - True if the array has at least one non-empty value
 */
export function hasAnyArrayData(arr) {
  if (!arr || arr.length === 0) return false;
  return arr.some((v) => !isEmptyValue(v));
}

